import Select from 'react-select';
import DatePicker from '../../../components/forms/date-picker.component';
import Input from '../../../components/forms/input.component';
import Icon from '../../../components/forms/icon.component';
import type { ReportFilters } from './reports.types';

const VERDICT_OPTS = [
  { value: '', label: 'Todos los veredictos' },
  { value: 'human', label: 'Humano' },
  { value: 'voicemail', label: 'Buzón (603)' },
  { value: 'unknown', label: 'Sin veredicto' },
  { value: 'bypass', label: 'Bypass (sin CPD)' }
];
const ANSWERED_OPTS = [
  { value: '', label: 'Contestadas y no' },
  { value: 'true', label: 'Solo contestadas' },
  { value: 'false', label: 'Solo no contestadas' }
];

export default function ReportsFilters({
  value,
  onChange,
  onApply,
  loading
}: {
  value: ReportFilters;
  onChange: (next: ReportFilters) => void;
  onApply: () => void;
  loading: boolean;
}) {
  const set = (k: keyof ReportFilters, v: string) =>
    onChange({ ...value, [k]: v } as ReportFilters);
  const sel = (opts: { value: string; label: string }[], k: keyof ReportFilters) => (
    <Select
      options={opts}
      className="form-select-custom"
      classNamePrefix="form-select-custom"
      value={opts.find((o) => o.value === value[k]) ?? opts[0]}
      onChange={(o: any) => set(k, o?.value ?? '')}
    />
  );

  return (
    <div className="card shadow-sm border-0 rounded-4">
      <div className="card-body p-5">
        <form
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            onApply();
          }}
        >
          <div className="row g-4 align-items-end">
            <div className="col-md-4 col-xl-3">
              <label className="form-label">Rango de fechas</label>
              <DatePicker
                initialStart={value.from}
                initialEnd={value.to}
                onDatesChange={(r: any) =>
                  onChange({
                    ...value,
                    from: r.start.format('YYYY-MM-DD'),
                    to: r.end.format('YYYY-MM-DD')
                  })
                }
              />
            </div>
            <div className="col-md-4 col-xl-2">
              <Input
                label="Operador"
                placeholder="coppel, banorte…"
                value={value.operatorId}
                onChange={(e: any) => set('operatorId', e.target.value)}
              />
            </div>
            <div className="col-md-4 col-xl-2">
              <Input
                label="Grupo de ruta"
                type="number"
                placeholder="10, 20, 30…"
                value={value.routeGroupId}
                onChange={(e: any) => set('routeGroupId', e.target.value)}
              />
            </div>
            <div className="col-md-4 col-xl-2">
              <label className="form-label">Veredicto CPD</label>
              {sel(VERDICT_OPTS, 'cpdVerdict')}
            </div>
            <div className="col-md-4 col-xl-3">
              <label className="form-label">Contestada</label>
              {sel(ANSWERED_OPTS, 'answered')}
            </div>
            <div className="col-md-4 col-xl-3">
              <Input
                label="Hangup cause"
                placeholder="CALL_REJECTED, NORMAL_CLEARING…"
                value={value.hangupCause}
                onChange={(e: any) => set('hangupCause', e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-md-4 col-xl-2">
              <Input
                label="Billsec mín (s)"
                type="number"
                value={value.billsecMin}
                onChange={(e: any) => set('billsecMin', e.target.value)}
              />
            </div>
            <div className="col-md-4 col-xl-2">
              <Input
                label="Billsec máx (s)"
                type="number"
                value={value.billsecMax}
                onChange={(e: any) => set('billsecMax', e.target.value)}
              />
            </div>
            <div className="col-md-12 col-xl-5 d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-light fw-bold fs-7"
                onClick={() =>
                  onChange({
                    ...value,
                    operatorId: '',
                    routeGroupId: '',
                    cpdVerdict: '',
                    hangupCause: '',
                    answered: '',
                    billsecMin: '',
                    billsecMax: ''
                  })
                }
              >
                Limpiar filtros
              </button>
              <button type="submit" className="btn btn-primary fw-bold fs-7" disabled={loading}>
                <Icon icon="ki-magnifier" size="fs-4 me-1" />
                {loading ? 'Consultando…' : 'Consultar'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
